// extracted by mini-css-extract-plugin
export var questionItem__question = "QuestionItem-module--questionItem__question--1-Pp_";
export var questionItem__item = "QuestionItem-module--questionItem__item--2MhTF";
export var questionItem__text = "QuestionItem-module--questionItem__text--1AQXt";
export var questionItem__subtext = "QuestionItem-module--questionItem__subtext--31LkW";